import apiClient from "./apiClient";
import { ActivityLogResponse } from "../models/ResponseModels/ActivityLogResponse";
import { PaginatedResponse } from "../models/ResponseModels/PaginatedResponse";

export interface ActivityLogFilters {
  page?: number;
  per_page?: number;
  search?: string;
  source?: string;
  action?: string;
  account_id?: number;
  actor_user_id?: number;
}

export const getActivityLogsRequest = async (
  filters: ActivityLogFilters,
): Promise<PaginatedResponse<ActivityLogResponse>> => {
  const response = await apiClient.get<PaginatedResponse<ActivityLogResponse>>(
    "/admin/activity-logs",
    { params: filters },
  );

  return response.data;
};
